import React from 'react';
import { Box, Divider } from '@mui/material';
import { WidgetContent } from 'src/components/Widget/types';
import { DashboardDataReceiptsTotal } from 'src/api/services/types';
import StatContent from './StatContent';

const ReceiptsSummaryContent: WidgetContent<DashboardDataReceiptsTotal> = ({
  data,
  loading,
}) => {
  const receipts = data?.receipts;
  const expenses = data?.expenses;

  return (
    <Box
      display="flex"
      flexDirection="column"
      flex={1}
      width="100%"
      alignSelf="center"
      justifyContent="center"
    >
      <StatContent
        loading={loading}
        value={receipts ? receipts.total.toString() : undefined}
        type="חשבוניות"
      />
      <Divider sx={{ opacity: 0.6, mt: 2, mb: 4 }} />
      <StatContent
        loading={loading}
        value={expenses ? expenses.total.toString() : undefined}
        type="סכום הוצאות"
        statSuffix={expenses?.unit}
      />
    </Box>
  );
};

export default ReceiptsSummaryContent;
